import React from 'react';
import { ATMField, ATMForm, ATMGrid } from 'shared-it-appmod-ui';
import { isEditable } from 'src/constants';
import Lang from 'src/libraries/language';
import { SettingFormSchema } from 'src/models/setting.model';

type IProp = {
  formRef: React.RefObject<HTMLFormElement>;
  defaultValues: any;
  handleSubmit: (data) => void;
  handleEnable1: (value) => void;
  handleEnable2: (value) => void;
  handleEnable3: (value) => void;
  isEdit?: boolean;
};

const ConfigurationSettingsForm: React.FC<IProp> = ({
  formRef,
  defaultValues = {},
  handleSubmit,
  handleEnable1,
  handleEnable2,
  handleEnable3,
  isEdit = false,
}) => {
  if (isEdit) {
    handleEnable1(false);
  }

  return (
    <div className="form-container">
      <ATMForm
        ref={formRef}
        onSubmit={handleSubmit}
        mode="onChange"
        defaultValues={defaultValues}
        validationSchema={SettingFormSchema}
      >
        {({ control, errors }) => (
          <ATMGrid>
            <ATMGrid.Row columns="equal">
              <ATMGrid.Column>
                {!isEdit && (
                  <ATMField
                    label={Lang.LBL_KEY}
                    name="key"
                    control={control}
                    as={ATMForm.Input}
                    placeholder={Lang.LBL_ENTER}
                    onChange={([_, val]) => {
                      if (val.value === '' || val.value === undefined) {
                        handleEnable1(true);
                      } else {
                        handleEnable1(false);
                      }
                      return val.value;
                    }}
                    clearable
                    required
                    error={errors.key}
                  />
                )}
                {isEdit && (
                  <>
                    <ATMField
                      label={Lang.LBL_KEY}
                      name="key"
                      control={control}
                      as={ATMForm.Input}
                      disabled
                    />
                  </>
                )}
              </ATMGrid.Column>
              <ATMGrid.Column>
                <ATMField
                  label={Lang.LBL_VALUE}
                  name="value"
                  control={control}
                  as={ATMForm.Input}
                  placeholder={Lang.LBL_ENTER}
                  onChange={([_, val]) => {
                    if (val.value === '' || val.value === undefined) {
                      handleEnable2(true);
                    } else {
                      handleEnable2(false);
                    }
                    return val.value;
                  }}
                  clearable
                  required
                  error={errors.value}
                />
              </ATMGrid.Column>
            </ATMGrid.Row>
            <ATMGrid.Row columns="1">
              <ATMGrid.Column>
                <ATMField
                  label={Lang.LBL_DESCRIPTION}
                  name="description"
                  control={control}
                  as={ATMForm.TextArea}
                  placeholder={Lang.LBL_ENTER}
                  onChange={([_, val]) => {
                    if (val.value === '' || val.value === undefined) {
                      handleEnable3(true);
                    } else {
                      handleEnable3(false);
                    }
                    return val.value;
                  }}
                  clearable
                  required
                  error={errors.description}
                />
                <ATMField
                  name="editFlag"
                  control={control}
                  as={ATMForm.Input}
                  defaultValue={isEditable.true}
                  type="hidden"
                />
                <ATMField
                  name="settingsId"
                  control={control}
                  as={ATMForm.Input}
                  defaultValue={defaultValues.settingsId ?? null}
                  type="hidden"
                />
              </ATMGrid.Column>
            </ATMGrid.Row>
          </ATMGrid>
        )}
      </ATMForm>
    </div>
  );
};

export default ConfigurationSettingsForm;
